import { useState, useEffect, useCallback } from 'react';

/**
 * Спільний стан шапки «Команди диспетчера» (/sko) — РЕДИЗАЙН.
 *
 * Перемикач секцій (Inbox · PRS · Curtailment · Про СКО) винесено в топбар за
 * §6 дизайн-контракту: раніше це була самописна «браузерна» смуга вкладок із
 * власною геометрією, якої немає більше ніде в кабінеті.
 *
 * Прийом той самий, що useMarketPricesUi / useTradingUi / useComdispUi:
 * модульний state + CustomEvent-синхронізація в межах вкладки.
 */
const EV = 'helios:sko-ui-change';

export type SkoSection = 'inbox' | 'prs' | 'curtailment' | 'about';

const state = { section: 'inbox' as SkoSection };

const emit = () => window.dispatchEvent(new CustomEvent(EV));

export function useSkoUi() {
  const [, force] = useState(0);
  useEffect(() => {
    const refresh = () => force((x) => x + 1);
    window.addEventListener(EV, refresh);
    return () => window.removeEventListener(EV, refresh);
  }, []);

  const setSection = useCallback((s: SkoSection) => {
    if (state.section !== s) { state.section = s; emit(); }
  }, []);

  return { section: state.section, setSection };
}
